module.exports=function(scope){ return `<div id="${scope.id}" class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label getmdl-select getmdl-select__fullwidth ${scope.cls}">
    <input type="text" id="${scope.id}-input" class="mdl-textfield__input" value="" readonly ${scope.required} tabIndex="-1">
    <input type="hidden" value="" name="${scope.id}-input">
    <label class="mdl-textfield__label" for="${scope.id}-input">${scope.label}</label>
    <ul for="${scope.id}-input" class="mdl-menu mdl-menu--bottom-left mdl-js-menu">
        ${scope.items.map(i => `<li class="mdl-menu__item" ${scope.value == i ? 'data-selected="true"' : ''}>${i}</li>`).join('')}
    </ul>
    <span class="mdl-textfield__error">${scope.error}</span>
</div>`};